<div class="entity-onboard-wrapper">
  <div class="d-flex justify-space-between">
    <div class="eo-title-container">
      <app-button [type]="backButton?.type" [option]="backButton?.option" [label]="backButton?.label"
        [color]="backButton?.color" [icon]="backButton?.icon" [iconColor]="backButton?.iconColor"
        (clicked)="onBackButtonClick()"></app-button>
      <div class="eo-title-wrapper">
        <span class="eo-title">{{ pageTitle }}</span>
        <span class="eo-subtitle">{{ pageSubTitle }}</span>
      </div>
    </div>
    <!--Apply conditions!!!-->
    <div *ngIf="_content?.bulkUploadEnable && !_routerState?.entityId">
      <button class="eo-bulk-upload" (click)="onBulkUpload()">
       <div>
        <img src="../../../../assets/images/add_circle.svg" alt="Add"/>
       </div> 
       <div>
        {{_content?.bulkUploadButtonLabel}}
       </div> 
      </button>
    </div>
  </div>
  <div class="eo-form">
    <form [formGroup]="form">
      <ng-container *ngFor="let formSection of content?.formField;">
        <div class="eo-form-section">
          <span class="eof-title" *ngIf="formSection?.visible">{{ formSection?.sectionName }}</span>
          <div class="eof-field-container">
            <ng-container *ngFor="let formField of formSection?.fields;" [ngTemplateOutlet]="formFieldNode"
              [ngTemplateOutletContext]="{
                $implicit: formField,
                formGroupName: formSection?.sectionKey,
                form: form,
                sectionKey: formSection?.sectionKey
              }">
            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-template #formFieldNode let-data let-formGroupName="formGroupName" let-form="form" let-sectionKey="sectionKey">
        <ng-container *ngIf="data?.children?.length; else noChildren;">
          <ng-container *ngFor="let formField of data?.children;" [ngTemplateOutlet]="formFieldNode"
            [ngTemplateOutletContext]="{
              $implicit: formField,
              formGroupName: data?.key,
              form: getFormGroupByControlKey(form, formGroupName),
              sectionKey: sectionKey
            }">
          </ng-container>
        </ng-container>
        <ng-template #noChildren>
          <ng-container [formGroup]="form">
            <ng-container *ngIf="data?.visible" [formGroupName]="transformControlKey(formGroupName)">
              <ng-container [ngSwitch]="data?.fieldType">
                <ng-container *ngSwitchCase="FORM_FIELD?.[0]">
                  <ng-container [ngSwitch]="data?.inputType">
                    <app-number *ngSwitchCase="FORM_FIELD_INPUT?.[0]" [formControlName]="data?.key"
                      [label]="data?.label" [disabled]="data?.disabled" appearance="outline" [validator]="true" [formSubmit]="isFormSubmitted">
                    </app-number>
                    <app-input *ngSwitchDefault [formControlName]="data?.key" [label]="data?.label"
                      appearance="outline" [validator]="true" [formSubmit]="isFormSubmitted">
                    </app-input>
                  </ng-container>
                </ng-container>
                <app-select-box *ngSwitchCase="FORM_FIELD?.[1]" [formControlName]="data?.key" [label]="data?.label"
                  [options]="data?.options" appearance="outline" [validator]="true" [formSubmit]="isFormSubmitted">
                </app-select-box>
                <app-slide-toggle *ngSwitchCase="FORM_FIELD?.[2]" [formControlName]="data?.key" [label]="data?.label"
                  class="eof-field-valign">
                </app-slide-toggle>
                <app-slide-toggle-group *ngSwitchCase="FORM_FIELD?.[3]" [formControlName]="data?.key" [options]="data?.toggleOptions" 
                  [title]="data?.label"></app-slide-toggle-group>
                <app-virtual-scroll-search-dropdown *ngSwitchCase="FORM_FIELD?.[5]" [options]="data?.options" [formLabel]="data?.label" [required]="data?.mandatory"
                  [validators]="getFieldValidations(data?.path)" [formSubmit]="isFormSubmitted" [selectedOption]="getSelectedOption(data?.path, data?.options)"
                  (valueChange)="onVirtualScrollValueSelection(data?.path, $event)">
                </app-virtual-scroll-search-dropdown>
                <app-multi-select-box *ngSwitchCase="FORM_FIELD?.[6]" [formControlName]="data?.key" [label]="data?.label"
                  [options]="data?.options" appearance="outline" [validator]="true" [formSubmit]="isFormSubmitted">
                </app-multi-select-box>    
                <div class="evidence-box" *ngSwitchCase="FORM_FIELD?.[7]">
                  <div *ngIf="!image">
                    <div class="evidence-header">
                      {{ data?.label }}
                    </div>
                    <div class="m-12">
                      <app-file [formControl]="file" [content]="fileContent?.file" [folder]="'documents'" [preSignedUrl]="preSignedUrl"
                        [image]="'kb_defaultfile.svg'" [isFileTypeImage]="false" [requiredFileSize]="maxFileSize" [isImageOnly]="true"
                        [requiredFileType]="fileMimeTypes" [startUpload]="startFileBlobUpload"
                        (uploadResponse)="uploadResponse($event, 'file')" [pageType]="'addDeviceForm'">
                      </app-file>
                    </div>
                    <div class="note-text m-12"><a>Note: </a>{{ tenantConfig?.addVehicle?.imageUpload?.noteText }}</div>
                    <div [ngClass]="{'d-flex space-between m-12': errorMessage || (file?.value?.size / 1024) > +tenantConfig?.addVehicle?.imageUpload?.maxSize}">
                      <mat-error *ngIf="errorMessage" class="file-error">
                        <em class="fas fa-exclamation-circle mr-2"></em>
                        {{ generalService?.getErrorMessage('Chassis Number', 'required') }}
                      </mat-error>
                      <mat-error *ngIf="!errorMessage && (file?.value?.size / 1024) > +tenantConfig?.addVehicle?.imageUpload?.maxSize" class="file-error">
                        <em class="fas fa-exclamation-circle mr-2"></em>
                        {{ tenantConfig?.addVehicle?.imageUpload?.sizeErrorMessage }}
                      </mat-error>
                      <button mat-raised-button type="submit" class="custom-button-submit" (click)="onFormSubmit(data?.path)"
                        [disabled]="!file?.value || (file?.value?.size / 1024) > +tenantConfig?.addVehicle?.imageUpload?.maxSize">Upload</button>
                    </div>
                  </div>
                  <div *ngIf="image">
                    <div class="evidence-header">
                      {{ 'Image' }}
                    </div>
                    <div class="m-12">
                      <img [src]="image" alt="image" class="v-image" />
                      <button mat-raised-button type="submit" class="custom-button-submit" (click)="onClearImage(data?.path)">Clear</button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </ng-template>
    </form>
  </div>
  <div class="eo-action-list -end">
    <ng-container *ngFor="let action of formActionList;">
      <app-button [label]="action?.label" [type]="action?.type" [color]="action?.color ?? null"
        (clicked)="onFormActionClick($event, action)" [disabled]="action?.action !== ACTION_MODE?.CANCEL && isSubmitDisabled()"
        *ngIf="(action?.action === formStatus) || (action?.action === ACTION_MODE?.CANCEL)">
      </app-button>
    </ng-container>
  </div>
</div>